import * as Yup from 'yup';
import { useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { Icon } from '@iconify/react';
import eyeFill from '@iconify/icons-eva/eye-fill';
import eyeOffFill from '@iconify/icons-eva/eye-off-fill';

import { useAuth } from '../../common/use-auth';
import { useRouter } from '../../common/use-router';

// material
import {
  Link,
  Stack,
  Checkbox,
  TextField,
  IconButton,
  InputAdornment,
  FormControlLabel
} from '@mui/material';
import { LoadingButton } from '@mui/lab';

import { useTranslation } from 'react-i18next';
// ----------------------------------------------------------------------

export default function LoginForm() {
  
  const [showPassword, setShowPassword] = useState(false);
  const {t} = useTranslation();
  const LoginSchema = Yup.object().shape({
    email: Yup.string().email('Email must be a valid email address').required('Email is required'),
    password: Yup.string().required('Password is required')
  });

  const router = useRouter();
  const navigate = useNavigate();
  const {user, signin, redirectUrl} = useAuth();

  const [serverError, setServerError] = useState(null);

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
      remember: true
    },
    validationSchema: LoginSchema,
    onSubmit: async (values) => {
      setServerError(null);
      console.log(values);
      var user = await signin(values.email, values.password);
      if (user !== false){
 
 
         if (redirectUrl !== null){
           router.push(redirectUrl);
         }
         else
         {
           router.push("/", { replace: true });
         }
      }
      else{
        console.log("serverError!!");
        setServerError("check your credentials!!");
      }
      
    }
  });

  const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps } = formik;

  const handleShowPassword = () => {
    setShowPassword((show) => !show);
  };

  var pwError = errors.password;


  if (serverError !== null){
    pwError = serverError;
  }
  
  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
        <Stack spacing={3}>
          <TextField
            fullWidth
            autoComplete="username"
            type="email"
            label={t("Email address")}
            {...getFieldProps('email')}
            error={Boolean(touched.email && errors.email)}
            helperText={touched.email && errors.email }
          />

          <TextField
            fullWidth
            autoComplete="current-password"
            type={showPassword ? 'text' : 'password'}
            label={t("Password")}
            {...getFieldProps('password')}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleShowPassword} edge="end">
                    <Icon icon={showPassword ? eyeFill : eyeOffFill} />
                  </IconButton>
                </InputAdornment>
              )
            }}
            error={Boolean(touched.password && pwError)}
            helperText={touched.password && (pwError)}
          />
        </Stack>

        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }}>
          <FormControlLabel
            control={<Checkbox {...getFieldProps('remember')} checked={values.remember} />}
            label={t("login_remember_me")}
          />

          {/* <Link component={RouterLink} variant="subtitle2" to="#">
          {t("login_forgot_password")}
          </Link> */}
        </Stack>

        <LoadingButton
          fullWidth
          size="large"
          type="submit"
          variant="contained"
          loading={isSubmitting}
        >
          {t("login_btn")}
        </LoadingButton>
      </Form>
    </FormikProvider>
  );
}
